<template>
  <b-row>
    <b-col
      class="vote-for d-flex flex-sm-column justify-content-between align-items-center justify-content-sm-start"
      cols="12"
      sm="4"
    >
      <h2>Pour</h2>
      <b-form-checkbox
        name="for"
        :value="voteTypes.for"
        :unchecked-value="null"
        :checked="mandateCurrentResolutionVote ? mandateCurrentResolutionVote.vote : null"
        class="voting-checkbox green"
        @change="setVote(voteTypes.for)"
      />
    </b-col>
    <b-col
      class="vote-against d-flex flex-sm-column justify-content-between align-items-center justify-content-sm-start"
      cols="12"
      sm="4"
    >
      <h2>Contre</h2>
      <b-form-checkbox
        name="against"
        :value="voteTypes.against"
        :unchecked-value="null"
        :checked="mandateCurrentResolutionVote ? mandateCurrentResolutionVote.vote : null"
        class="voting-checkbox red"
        @change="setVote(voteTypes.against)"
      />
    </b-col>
    <b-col
      class="vote-abstain d-flex flex-sm-column justify-content-between align-items-center justify-content-sm-start"
      cols="12"
      sm="4"
    >
      <h2>Abstention</h2>
      <b-form-checkbox
        name="against"
        :value="voteTypes.abstain"
        :unchecked-value="null"
        :checked="mandateCurrentResolutionVote ? mandateCurrentResolutionVote.vote : null"
        class="voting-checkbox grey"
        @change="setVote(voteTypes.abstain)"
      />
    </b-col>
  </b-row>
</template>

<script>
export default {
  props: {
    mandateCurrentResolutionVote: {
      type: Object,
      default: () => {
        return null;
      },
    },
  },
  methods: {
    setVote(voteType) {
      this.$emit("setVote", voteType);
    },
  },
};
</script>
